export default __webpack_public_path__ + "static/media/Dune-hd-1.3bf8582f.jpg";